export default function() {
  const widgetName = 'seoImagesWidget';
  const widgetOpts = seoImagesWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function() {
      const itemLogo = `<div class="card-widget-item logo"></div>`
      $(`#${widgetName}`).prepend(itemLogo);
      // append itemLogo after the second item
      $(`#${widgetName} .card-widget-item:nth-child(2)`).after(itemLogo);
      $(`#${widgetName} .card-widget-item`).find('.card-content').remove()
      const widgets = $(`#${widgetName} .card-widget-item`);
      applyAOS($(`#${widgetName}`), 'fade-right');
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 3,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false
  });

}